import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function GeotechnicalIndex() {
  const gradient = 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)'
  const accentColor = '#16a34a'

  const calculators = [
    {
      title: 'Capacidade de Estacas',
      description: 'Dimensionamento da capacidade de carga de estacas pelos métodos Aoki-Velloso e Décourt-Quaresma',
      path: '/geotecnia/estaca',
      icon: '🏔️',
      popular: true,
    },
    {
      title: 'Estabilidade de Muro de Arrimo',
      description: 'Avaliação de empuxo ativo/passivo, escorregamento e tombamento de muros em flexão.',
      path: '/geotecnia/muro-flexao',
      icon: '🛡️',
      popular: true,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>🏔️ Geotecnia</h1>
          <p className="subtitle">
            Ferramentas para avaliação e dimensionamento de fundações e interações solo-estrutura
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
              $upcoming={calc.upcoming}
              onClick={(event) => calc.upcoming && event.preventDefault()}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              {calc.upcoming && <span className="upcoming-badge">Em breve</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
